export const CHECKOUT_MORE_LINK = 'https://yandex.ru/support/search/ru/quick-purchase';
